import React from "react";
import SubHeader from "../../../common/subHeader";
import ATable from "../../../common/table";
import Formsy, { addValidationRule } from "formsy-react";
import Toaster from "toastr";
import Util from "../../../../util/util";
import Messages from "../../../../configurations/messages";
import FileUpload from "../../common/controls/FileUpload";
import { DiscoverFields } from "../../../../configurations/discoverConfigs/fields";
import DiscoverApi from "../../../../api/DiscoverApi";
import { Spinner } from "../../../common/spinner";
import { DiscoverConstants } from "../../../../configurations/discoverConfigs/discoverConstants";

addValidationRule("acceptedFormat", function(values, value, array) {
  let fileFormat = "";
  if (value) {
    fileFormat = value.type.split("/").pop();
    fileFormat = `.${fileFormat}`;
  }

  return array.indexOf(fileFormat) >= 0;
});

addValidationRule("maxFileSize", function(values, value, fileSize) {
  return value && value.size < fileSize ? true : false;
});

class CaseDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      sending: false,
      downloading: false,
      showAddCaseDocument: false
    };
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showAddCaseDocument = this.showAddCaseDocument.bind(this);
    this.getBase64 = this.getBase64.bind(this);
    this.createCaseDocumentObject = this.createCaseDocumentObject.bind(this);
    this.getCaseDocuments = this.getCaseDocuments.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
  }

  getCaseDocuments() {
    this.props.getCaseDocuments(this.props.caseDetails.caseNumber);
  }

  disableButton() {
    this.setState({ canSubmit: false });
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  showAddCaseDocument() {
    this.setState(prevState => ({
      showAddCaseDocument: !prevState.showAddCaseDocument
    }));
  }

  getBase64(file, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = callback;
  }

  createCaseDocumentObject(formData) {
    const { caseNumber } = this.props.caseDetails;
    let apiBody = {};
    this.getBase64(formData.image, e => {
      apiBody = {
        ...apiBody,
        fileFormat: formData.image.type.split("/").pop(),
        base64EncodedImage: e.target.result.split(",").pop()
      };
      this.handleSubmit(apiBody, caseNumber);
    });
  }

  onDownloadClick(documentId, e) {
    e.persist();
    e.target.disabled = true;
    e.target.innerText = "Downloading...";
    const { caseNumber } = this.props.caseDetails;
    DiscoverApi.downloadCaseDocuments(documentId, caseNumber)
      .then(response => {
        e.target.disabled = false;
        e.target.innerText = "Download";
        window.open(response.config.url, "_blank");
      })
      .catch(error => {
        e.target.disabled = false;
        e.target.innerText = "Download";
        Util.errorMessageToast(Toaster, error.data, [
          Messages.ERROR_DOWNLOADCASE_DOCUMENT
        ]);
      });
  }

  handleSubmit(data, caseNumber) {
    this.setState({ sending: true });
    DiscoverApi.addCaseDocuments(data, caseNumber)
      .then(response => {
        Toaster.success(Messages.SUCCESS_CASE_DOCUMENT);
        this.setState({
          sending: false
        });
        this.props.getCaseDocuments(caseNumber);
        this.showAddCaseDocument();
      })
      .catch(error => {
        this.setState({ sending: false });
        Util.errorMessageToast(Toaster, error.data.description, [
          `${Messages.ERROR_CASE_DOCUMENT}`
        ]);
      });
  }

  render() {
    const { documents, fetchingDocuments, casePermissions } = this.props;
    const { canSubmit, showAddCaseDocument, sending } = this.state;
    const columns = [
      {
        header: "Document Id",
        accessor: "documentId",
        width: 500
      },
      {
        header: "Document Owner",
        accessor: "documentOwner"
      },
      {
        header: "Received On",
        accessor: "receivedOn"
      },
      {
        header: "",
        accessor: "action",
        render: row => (
          <button
            className="btn btn-sm btn-primary"
            onClick={e => {
              this.onDownloadClick(row.row.documentId, e);
            }}
          >
            Download
          </button>
        )
      }
    ];
    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            <SubHeader title="Case Documents" />
          </div>
          <div className="col-sm-4 text-right">
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.addCaseDocument
            ) >= 0 ? (
              <button
                className="btn btn-primary"
                onClick={this.showAddCaseDocument}
              >
                {!showAddCaseDocument
                  ? "Add Case Document"
                  : "View Case Documents"}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <hr />
        {showAddCaseDocument && (
          <div className="row">
            <div className="col-xs-12">
              <div className="panel panel-default">
                <div className="panel-body">
                  <Formsy
                    onValidSubmit={this.createCaseDocumentObject}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref="addCaseDocument"
                    noValidate
                  >
                    <FileUpload
                      name={DiscoverFields.image.name}
                      label={DiscoverFields.image.label}
                      required={true}
                      description={DiscoverFields.image.description}
                      validations={{
                        acceptedFormat: DiscoverFields.image.acceptedFormats,
                        maxFileSize: DiscoverFields.image.maxFileSize
                      }}
                      validationErrors={{
                        acceptedFormat:
                          DiscoverFields.image.acceptedFormats &&
                          `Only files formats (${DiscoverFields.image.acceptedFormats.join(
                            ", "
                          )}) are allowed`,
                        maxFileSize:
                          DiscoverFields.image.maxFileSize &&
                          `File must not be larger than ${Math.floor(
                            DiscoverFields.image.maxFileSize / 1000
                          )}KB`
                      }}
                      acceptedFormats={DiscoverFields.image.acceptedFormats}
                    />
                    <button
                      className="btn btn-primary"
                      disabled={!canSubmit || sending}
                    >
                      {sending ? (
                        <Spinner color="#FFF" />
                      ) : (
                        "Submit Case Document"
                      )}
                    </button>
                  </Formsy>
                </div>
              </div>
            </div>
          </div>
        )}

        {fetchingDocuments ? (
          <div className="text-center">
            <Spinner size="120px" message="Fetching Case Documents" />
          </div>
        ) : !showAddCaseDocument ? (
          documents ? (
            <ATable
              className="-striped -highlight"
              tableData={documents}
              columns={columns}
              defaultPageSize={10}
              onRowClick={() => null}
            />
          ) : (
            <div className="text-center">
              <div className="alert alert-danger">
                {Messages.ERROR_CASE_DOCUMENTS}
              </div>
              <button
                className="btn btn-primary"
                onClick={this.getCaseDocuments}
              >
                Get Case Documents
              </button>
            </div>
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default CaseDocuments;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/CaseDocuments.js